import { ContentContainer } from '@/components/ui/content-container.component';
import { Skeleton } from '@/components/ui/skeleton.component';

export default function SearchHeaderLoading() {
  return (
    <>
      <div className="w-full flex justify-center bg-white py-3 border-b border-gray-200">
        <ContentContainer className="md:px-0 md:mx-auto md:max-w-[576px] lg:max-w-3xl px-3">
          <Skeleton className="h-12 w-full rounded-lg" />
        </ContentContainer>
      </div>

      <div className="w-full flex justify-center bg-gray-50 py-6">
        <ContentContainer className="md:px-0 md:mx-auto md:max-w-[576px] lg:max-w-3xl flex flex-col gap-2">
          <Skeleton className="h-6 w-100" />
          <Skeleton className="h-6 w-100" />
          <Skeleton className="h-3 w-80" />

          <div className="inline-flex gap-2 mt-3">
            <Skeleton className="h-8 w-24" />
            <Skeleton className="h-8 w-24" />
          </div>
        </ContentContainer>
      </div>
    </>
  );
}
